import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts';
import '@/assets/styles/variables.scss'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
import {
  LMap,
  LTileLayer,
  LMarker,
  LControlScale,
  LGeoJson,
  LControl,
  LPopup,
  LControlLayers,
} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon, } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false;

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-control-scale', LControlScale);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-control', LControl);
Vue.component('l-popup', LPopup);
Vue.component('l-control-layers', LControlLayers);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
